import { Node, mergeAttributes } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'

export interface VideoOptions {
	HTMLAttributes: Record<string, any>
}

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		video: {
			/**
			 * Add a video
			 */
			setVideo: (options: { src: string; type?: string }) => ReturnType
		}
	}
}

export const Video = Node.create<VideoOptions>({
	name: 'video',

	group: 'block',

	draggable: true,

	addOptions() {
		return {
			HTMLAttributes: {
				class: 'video-wrapper',
			},
		}
	},

	addAttributes() {
		return {
			src: {
				default: null,
			},
			type: {
				default: 'video/mp4',
			},
			width: {
				default: '100%',
			},
			controls: {
				default: true,
			},
		}
	},

	parseHTML() {
		return [
			{
				tag: 'video',
			},
		]
	},

	renderHTML({ HTMLAttributes }) {
		return [
			'video',
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
				controls: HTMLAttributes.controls ? HTMLAttributes.controls : null,
				controlsList: 'nodownload',
			}),
			['source', { src: HTMLAttributes.src, type: HTMLAttributes.type }],
		]
	},

	addCommands() {
		return {
			setVideo:
				options =>
				({ commands }) => {
					return commands.insertContent({
						type: this.name,
						attrs: options,
					})
				},
		}
	},

	addProseMirrorPlugins() {
		return [
			new Plugin({
				key: new PluginKey('videoPlugin'),
				props: {
					handleDOMEvents: {
						paste: (_view, _event) => {
							return false
						},
					},
				},
			}),
		]
	},
})
